export default __webpack_public_path__ + "static/media/D46FAE12-DDDC-4D74-8D12-F6BBC58E0D9A.74f5b57d.jpeg";